/*
 * Opens product documents in an in-page preview before the customer commits to
 * downloading. Shopify serves files from the CDN, a different origin, so the
 * anchor's `download` attribute is ignored by browsers anyway — this gives the
 * "look first, then save" behaviour explicitly instead of relying on that.
 *
 * Falls back to the anchor's normal behaviour (open in a new tab) when the file
 * cannot be embedded: non-PDFs, and mobile browsers such as iOS Safari that
 * render an empty frame for PDF iframes.
 */
(function () {
  'use strict';

  var dialog = null;
  var frame = null;
  var titleEl = null;
  var downloadLink = null;
  var newTabLink = null;

  function canPreview(url) {
    if (!url) return false;

    var path = url.split('?')[0].toLowerCase();
    if (path.slice(-4) !== '.pdf') return false;

    // iOS/Android browsers generally render PDF iframes as a blank box.
    if (window.matchMedia('(max-width: 749px)').matches) return false;

    // Explicitly reported as unavailable (e.g. a browser with the viewer off).
    if (navigator.pdfViewerEnabled === false) return false;

    return true;
  }

  function build() {
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'filazoo-doc-preview';
    dialog.innerHTML = [
      '<div class="filazoo-doc-preview__head">',
      '  <span class="filazoo-doc-preview__title"></span>',
      '  <div class="filazoo-doc-preview__actions">',
      '    <a class="filazoo-doc-preview__action" data-new-tab target="_blank" rel="noopener">Open in new tab</a>',
      '    <a class="filazoo-doc-preview__action filazoo-doc-preview__action--primary" data-download target="_blank" rel="noopener" download>Download</a>',
      '    <button class="filazoo-doc-preview__close" type="button" aria-label="Close preview">&times;</button>',
      '  </div>',
      '</div>',
      '<iframe class="filazoo-doc-preview__frame" title="Document preview"></iframe>'
    ].join('');

    frame = dialog.querySelector('.filazoo-doc-preview__frame');
    titleEl = dialog.querySelector('.filazoo-doc-preview__title');
    downloadLink = dialog.querySelector('[data-download]');
    newTabLink = dialog.querySelector('[data-new-tab]');

    dialog.querySelector('.filazoo-doc-preview__close').addEventListener('click', function () {
      dialog.close();
    });

    // Clicking the backdrop closes; clicks inside the panel must not bubble out.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    // Stop the embedded document from loading in the background once closed.
    dialog.addEventListener('close', function () {
      frame.removeAttribute('src');
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  function open(url, label) {
    build();

    titleEl.textContent = label || 'Document preview';
    downloadLink.href = url;
    newTabLink.href = url;
    frame.src = url;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
      return true;
    }

    return false;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-download-preview]') : null;
    if (!link) return;

    // Let modified clicks (new tab, save as) behave normally.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    var url = link.getAttribute('href');
    if (!canPreview(url)) return;

    if (open(url, link.getAttribute('data-preview-title'))) {
      event.preventDefault();
    }
  });
})();
